import * as React from 'react';
import { GuideStep } from '../guide';
import GuideStepRowSummary from './GuideStepRowSummary';
import GuideStepEditForm from './GuideStepEditForm';

export interface GuideStepRowProps {
  index: number;
  step: GuideStep;
  onChange: Function;
  onDelete: Function;
  canAddBloomStep: boolean;
  canAddPourStep: boolean;
}

export interface GuideStepRowState {
  step: GuideStep;
  editing: boolean;
}

type Props = {
  canAddBloomStep: boolean;
  canAddPourStep: boolean;
  index: number;
  onChange: Function;
  onDelete: Function;
  step: GuideStep;
  isEditing?: boolean;
};

export default function GuideStepRow(props: Props) {
  console.log("ROW", props.index, props.step, props.isEditing);

  const [editing, setEditing] = React.useState(
    props.isEditing || props.step.id.length === 0,
  );

  React.useEffect(() => {
    setEditing(props.isEditing);
  }, [props]);

  return (
    <div className="pv3 bb b--black-10 bw">
      {editing ? (
        <GuideStepEditForm {...props} />
      ) : (
        <GuideStepRowSummary step={props.step} setEditing={setEditing} />
      )}
    </div>
  );
}
